import Swiper from 'swiper/bundle';

jQuery(function($) {
  if($('.fv-slider').length) {
    var mySwiper = new Swiper('.fv-slider', {
      loop: true,
      effect: 'fade',
      speed: 2000,
      autoplay: {
        delay: 3000,
      },
    })
  }
});